import React from "react";
import { HeadLine } from "../modules/HeadLine";
import { AddAccount, PaymentMethodsTable } from "../modules/PaymentMethods";
import styled from "@emotion/styled";
import { PayPalCheckoutButton } from "../modules/PaymentMethods/Components/PayPalCheckoutButton";

const AddAccountWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const AddAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  padding: 1rem;
  gap: 1rem;
  align-items: center;
`;

const PaymentMethodsContainer = styled.div`
  height: ${({ height }) => `${height}px`};
  overflow-y: auto;
`;

const PaymentMethods = () => {
  return (
    <div style={{ flex: "80%", padding: "2rem" }}>
      <HeadLine
        headingText={"Payment Methods"}
        tagLine={"Choose a default payment method or add a new one"}
      />
      <AddAccountWrapper>
        <AddAccountContainer>
          <AddAccount />
          <PayPalCheckoutButton />
        </AddAccountContainer>
      </AddAccountWrapper>
      <PaymentMethodsContainer height={window.innerHeight - 250}>
        <PaymentMethodsTable />
      </PaymentMethodsContainer>
    </div>
  );
};

PaymentMethods.propTypes = {};

export default PaymentMethods;
